/** "2 waiting for signal": what the phone is holding that the office has not
 * yet got. Tapping it sends now rather than at the next reconnect; with
 * nothing waiting it says so, because "is it sent?" is the question a crew
 * asks at the end of a day in a dead zone. */
export function PendingBadge({ pending, onFlush }: { pending: number; onFlush: () => void }) {
  if (pending === 0) {
    return <span className="sync-badge sync-clear">All sent ✓</span>;
  }
  return (
    <button type="button" className="sync-badge sync-waiting" onClick={onFlush} title="Send now">
      {pending} waiting for signal
    </button>
  );
}
